import { useEffect, useState } from "react";
import "./HomeImageCarousel.css";

function HomeImageCarousel() {
  const images = [
    
    "/assets/Gauseva/Gauseva4.jpeg",
    "/assets/Gauseva/Gauseva5.jpeg",
    "/assets/Gauseva/Gauseva6.jpeg",
    "/assets/Gauseva/Gauseva7.jpeg",
    "/assets/Gauseva/Gauseva8.jpeg",
    "/assets/Gauseva/Gauseva9.jpeg",
    "/assets/Gauseva/Gauseva10.jpeg",
    "/assets/Gauseva/Gauseva11.jpeg",
    "/assets/Gauseva/Gauseva12.jpeg",
    "/assets/Gauseva/Gauseva13.jpeg",
    "/assets/Gauseva/Gauseva14.jpeg",
    "/assets/Gauseva/Gauseva15.jpeg",
  ];

  const [index, setIndex] = useState(0);

  // Auto slide every 3 seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000);

    return () => clearInterval(timer);
  }, [images.length]);

  // Always get exactly 3 images, wrapping around
  const getVisibleImages = () => {
    let result = [];
    for (let i = 0; i < 3; i++) {
      result.push(images[(index + i) % images.length]);
    }
    return result;
  };

  return (
    <div>
      <h2 className="section-title">Memories Over The Years</h2>
      <div className="image-carousel">
        {getVisibleImages().map((img, i) => (
          <div className="image-card" key={`${index}-${i}`}>
            <img
              src={img}
              alt={`carousel-${i}`}
              onError={(e) => {
                console.error("Image not found:", e.target.src);
                e.target.style.display = "none"; // hide broken images
              }}
            />
          </div>
        ))}
      </div>
    </div>
  );
}

export default HomeImageCarousel;
